import React from "react"
import { Container, Row, Col } from "reactstrap"
import { useTranslation } from "react-i18next"
import Colors from "constants/Colors"

const CustomTabs = ({ tabs = [], activeTab, onChange }) => {
  const {
    i18n: { language },
  } = useTranslation()

  return (
    <Container fluid className="p-0">
      <Row>
        <Col xs={12}>
          <div
            style={{
              overflowX: "auto",
              whiteSpace: "nowrap",
              borderBottom: "1px solid #ddd",
              direction: language === "en" ? "ltr" : "rtl",
              WebkitOverflowScrolling: "touch", // Smooth scrolling for iOS
            }}
          >
            {tabs.map(tab => (
              <div
                key={tab.id}
                onClick={() => onChange(tab.id)}
                style={{
                  display: "inline-block",
                  cursor: "pointer",
                  padding: "10px 20px",
                  color: activeTab === tab.id ? Colors.primary : Colors.white,
                  borderBottom:
                    activeTab === tab.id
                      ? `2px solid ${Colors.primary}`
                      : "2px solid transparent",
                  fontWeight: activeTab === tab.id ? "bold" : "normal",
                  transition: "all 0.3s ease",
                }}
              >
                {tab.label}
              </div>
            ))}
          </div>
        </Col>
      </Row>
    </Container>
  )
}

export default CustomTabs
